import { Injectable } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { LeftNavType, TreeItem } from '../../event-details-common/event-details-common.models';

@Injectable({ providedIn: 'root' })
export class NavigationTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackRegionToggle(region: TreeItem): void {
        this.trackingService.track(trackingConstants.EVENT_NAVIGATION_MENUS, {
            [trackingConstants.PAGE_SITE_SECTION]: 'Navigation',
            [trackingConstants.PAGE_NAVIGATION_MENUS]: region.expanded
                ? `LeftNav_PrePlay_Expand_RB_${region.id}`
                : `LeftNav_PrePlay_Collapse_RB_${region.id}`,
        });
    }

    trackSportToggle(sport: TreeItem): void {
        this.trackingService.track(trackingConstants.EVENT_NAVIGATION_MENUS, {
            [trackingConstants.PAGE_SITE_SECTION]: 'Navigation',
            [trackingConstants.PAGE_NAVIGATION_MENUS]: sport.expanded
                ? `LeftNav_inPlay_Expand_SB_${sport.id}`
                : `LeftNav_inPlay_Collapse_SB_${sport.id}`,
        });
    }

    trackLeagueToggle(league: TreeItem, leftNavType: LeftNavType): void {
        const navigationMenus = leftNavType === LeftNavType.Live ? 'LeftNav_inPlay' : 'LeftNav_PrePlay';

        this.trackingService.track(trackingConstants.EVENT_NAVIGATION_MENUS, {
            [trackingConstants.PAGE_SITE_SECTION]: 'Navigation',
            [trackingConstants.PAGE_NAVIGATION_MENUS]: league.expanded
                ? `${navigationMenus}_Expand_LN_${league.id}`
                : `${navigationMenus}_Collapse_LN_${league.id}`,
        });
    }

    trackMarketsToggle(visible: boolean, leftNavType: LeftNavType): void {
        const navigationMenus = leftNavType === LeftNavType.Live ? 'LeftNav_inPlay' : 'LeftNav_PrePlay';

        this.trackingService.track('Event.Functionality.ShowHideBets', {
            [trackingConstants.PAGE_SITE_SECTION]: 'Navigation',
            [trackingConstants.PAGE_REFERRING_ACTION]: visible ? `${navigationMenus}_ShowBets` : `${navigationMenus}_HideBets`,
        });
    }
}
